class TabsJS extends HTMLElement {

	constructor( opts ) {
		super();

		const DEFAULTS = {
			'selector': '.tabsjs',
			'responsiveBreak': 767
		}

		this.options = Object.assign( DEFAULTS, opts );
		this.elems = this.querySelectorAll('.tabsjs');

		// skip building tabs if they were already initialized
		this.skipIfInitialized = ( tabsElem ) => {

			// skip element if already initialized
			if( tabsElem.classList.contains('tabsjs__initialized') ) {
				return;
			}

		}

		this.handleNavigation();
		this.handleResponsive();

	}

	// navigation: assign click events
	handleNavigation() {

		let tabs = this.elems,
		tabsStyle = this.options.type;

		// walk on all tabs on the page
		tabs.forEach( ( el, i ) => {

			let tabsElem = el;

			this.skipIfInitialized( tabsElem );

			tabsElem.addEventListener( 'click', function( e ){

				if( e.target && e.target.classList.contains( 'tabsjs__nav_link') ) {
					e.preventDefault();

					let activeTabIndex;

					// if we click on main navigation link
					if( e.target.parentElement.classList == 'tabsjs__nav' ) {
						activeTabIndex = Array.prototype.slice.call( e.target.parentElement.children ).indexOf( e.target );

					// if we click on accordion nav link
					} else {
						activeTabIndex = Array.prototype.slice.call( e.target.parentElement.parentElement.children ).indexOf( e.target.parentElement ) - 1;
					}

					let tabsContent = tabsElem.getElementsByClassName( 'tabsjs__content'),
					mainNavLinks = tabsElem.querySelectorAll( '.tabsjs__nav > .tabsjs__nav_link'),
					accordionNavLinks = tabsElem.querySelectorAll( '.tabsjs__content > .tabsjs__nav_link');

					// toggle accordion panel
					if( ( tabsStyle == 'accordion' || tabsElem.classList.contains( 'is__responsive') ) && e.target.classList.contains( 'is__active') ) {
						tabsContent[ activeTabIndex ].classList.remove( 'is__active');
						mainNavLinks[ activeTabIndex ].classList.remove( 'is__active');
						accordionNavLinks[ activeTabIndex ].classList.remove( 'is__active');
						return;
					}

					// remove active class for inactive tabs
					for( let i = 0; i < tabsContent.length; i++ ) {
						tabsContent[ i ].classList.remove( 'is__active');
					}

					// add active class for a current (active) tab
					tabsContent[ activeTabIndex ].classList.add( 'is__active');

					// add active classes and remove inactive for main nav links
					mainNavLinks.forEach( ( el ) => {
						el.classList.remove( 'is__active');
					});

					mainNavLinks[ activeTabIndex ].classList.add( 'is__active');

					// add active classes and remove inactive for accordion nav links
					accordionNavLinks.forEach( ( el ) => {
						el.classList.remove( 'is__active');
					});									

					accordionNavLinks[ activeTabIndex ].classList.add( 'is__active');

				}

			});

		});

	}

	// responsive: tabs to accordion
	handleResponsive() {

		let tabs = this.elems,
		responsiveClassName = 'is__responsive',
		tabsStyle = this.options.type;

		window.addEventListener( 'resize', () => {

			// walk on all tabs on the page
			tabs.forEach( ( el, i ) => {

				let tabsElem = el,
				tabsContent = tabsElem.getElementsByClassName( 'tabsjs__content'),
				mainNavLinks = tabsElem.querySelectorAll( '.tabsjs__nav > .tabsjs__nav_link'),
				accordionNavLinks = tabsElem.querySelectorAll( '.tabsjs__content > .tabsjs__nav_link');

				this.skipIfInitialized( tabsElem );
				
				if( window.innerWidth > Number( this.options.responsiveBreak ) ) {

					tabsElem.classList.remove( responsiveClassName );

					if( tabsStyle != 'accordion' ) {
						// set first active tab if all of tabs were closed in accordion mode
						let openTabs = tabsElem.querySelectorAll( '.tabsjs__nav_link.is__active');
						if( openTabs.length == 0 ) {
							tabsContent[0].classList.add('is__active');
							mainNavLinks[0].classList.add('is__active');
							accordionNavLinks[0].classList.add('is__active');
						}
					}

				} else {

					tabsElem.classList.add( responsiveClassName );

				}

			});

		});

		// manually fire resize event
		window.dispatchEvent( new Event( 'resize' ));

	}

}

if (!customElements.get('tabsjs-component')) {
	customElements.define('tabsjs-component', TabsJS);
}




// Default Remove Active class for mobile

document.addEventListener('DOMContentLoaded', () => {

	function handleMobileTabs() {

		if (window.innerWidth <= 767) {

			document.querySelectorAll('.tabsjs').forEach((tabsElem) => {

				// remove active class from content
				tabsElem.querySelectorAll('.tabsjs__content').forEach((el) => {
					el.classList.remove('is__active');
				});

				tabsElem.querySelectorAll('.tabsjs__nav_link').forEach((el) => {
					el.classList.remove('is__active');
				});
			});

		}

	}
	handleMobileTabs();
	window.addEventListener('resize', handleMobileTabs);

});